import { Tooltip } from 'bootstrap';
import { Carousel } from '@fancyapps/ui/dist/carousel';
import { Arrows } from '@fancyapps/ui/dist/carousel/carousel.arrows';
import { Lazyload } from '@fancyapps/ui/dist/carousel/carousel.lazyload';
import { Sync } from '@fancyapps/ui/dist/carousel/carousel.sync';
import { l10n } from '~/lib/ui/src/js/fancyapps';

const carouselOptions = {
  ...l10n[window.DOCUMENT_LANG]
    ? {
      l10n: l10n[window.DOCUMENT_LANG]
    }
    : {},
  Dots: false,
  Thumbs: false,
  transition: 'slide'
};

function setTransform(
  ref, // CarouselInstance
  slide, // CarouselSlide
  state // { x: number; y: number; xPercent: number; yPercent: number; }
) {
  slide.el.style.transform = `translateY(${ref.getPages().length === 1 ? slide.offset : state.y}px)`;
}

export default () => {
  apos.util.widgetPlayers.product = {
    selector: '[data-product-widget]',
    player: function (element) {
      // Carousels
      const [ thumbsEl, mainEl ] = element.children;
      try {
        const mainCarousel = Carousel(mainEl, {
          ...carouselOptions,
          adaptiveHeight: (
            ref // CarouselInstance
          ) => {
            const curDim = ref.getViewportDim();
            const adaptiveHeight = !ref.prevViewportDim || curDim === ref.prevViewportDim;
            ref.prevViewportDim = curDim;
            // console.log('Adaptive height:', adaptiveHeight, curDim);
            return adaptiveHeight;
          }
        }, { Lazyload }).init();
        Carousel(thumbsEl, {
          ...carouselOptions,
          vertical: true,
          infinite: false,
          fill: true,
          dragFree: true,
          setTransform,
          Sync: {
            target: mainCarousel
          },
          style: {
            '--f-carousel-gap': '10px',
            '--f-carousel-slide-width': '6.6rem',
            '--f-carousel-slide-height': '6.6rem'
          }
        }, {
          Arrows,
          Sync
        }).init();
      } catch (_err) {}
      // Bootstrap Tooltips
      try {
        [ ...element.querySelectorAll('[data-bs-toggle="tooltip"]') ]
          .map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
      } catch (_err) {}
    }
  };
};
